import axios from "axios";
import { api } from "./api_route";

//Case Primary Information Routes --> Asset Details (Salary Attachment)

// =========== GET ALL SALARY ATTACHMENTS BY CASE ID ===========
export const getAllSalaryAttachmentsByCaseId = async (caseDetailsID) => {
    try {
        const response = await axios.get(
            `${api}/case/caseSalaryAttachment/all/${caseDetailsID}`
        );

        return {
            success: true,
            data: response.data.data || [],
            assetOwnedBy: response.data.assetOwnedBy || '',
            count: response.data.count || 0,
            message: response.data.message || "Salary Attachments fetched successfully",
        };
    } catch (error) {
        console.error("Error fetching salary attachments:", error);
        return {
            success: false,
            data: [],
            count: 0,
            message: error.response?.data?.message || "Failed to fetch salary attachments",
            error: error.response?.data?.error || error.message,
        };
    }
};

// =========== GET SINGLE SALARY ATTACHMENT BY ID ===========
export const getSalaryAttachmentById = async (salaryAttachmentID) => {
    try {
        const response = await axios.get(
            `${api}/case/caseSalaryAttachment/${salaryAttachmentID}`
        );

        return {
            success: true,
            data: response.data.data,
            message: response.data.message || "Salary Attachment fetched successfully",
        };
    } catch (error) {
        console.error("Error fetching salary attachment:", error);
        return {
            success: false,
            data: null,
            message: error.response?.data?.message || "Failed to fetch salary attachment",
            error: error.response?.data?.error || error.message,
        };
    }
};

// =========== CREATE NEW SALARY ATTACHMENT ===========
export const createSalaryAttachment = async (salaryData) => {
    try {
        const response = await axios.post(
            `${api}/case/caseSalaryAttachment`,
            salaryData
        );

        return {
            success: true,
            data: response.data.data,
            message: response.data.message || "Salary Attachment created successfully",
        };
    } catch (error) {
        console.error("Error creating salary attachment:", error);
        return {
            success: false,
            data: null,
            message: error.response?.data?.message || "Failed to create salary attachment",
            error: error.response?.data?.error || error.message,
        };
    }
};

// =========== UPDATE SALARY ATTACHMENT ===========
export const updateSalaryAttachment = async (salaryAttachmentID, salaryData) => {
    try {
        const response = await axios.put(
            `${api}/case/caseSalaryAttachment/${salaryAttachmentID}`,
            salaryData
        );

        return {
            success: true,
            data: response.data.data,
            message: response.data.message || "Salary Attachment updated successfully",
        };
    } catch (error) {
        console.error("Error updating salary attachment:", error);
        return {
            success: false,
            data: null,
            message: error.response?.data?.message || "Failed to update salary attachment",
            error: error.response?.data?.error || error.message,
        };
    }
};

// =========== DELETE SALARY ATTACHMENT ===========
export const deleteSalaryAttachment = async (salaryAttachmentID, updatedBy) => {
    try {
        const response = await axios.delete(
            `${api}/case/caseSalaryAttachment/${salaryAttachmentID}`,
            { data: { updatedBy } }
        );

        return {
            success: true,
            message: response.data.message || "Salary Attachment deleted successfully",
        };
    } catch (error) {
        console.error("Error deleting salary attachment:", error);
        return {
            success: false,
            message: error.response?.data?.message || "Failed to delete salary attachment",
            error: error.response?.data?.error || error.message,
        };
    }
};

// =========== HELPER FUNCTIONS ===========

export const formatSalaryAttachmentData = (data) => {
    const formatted = { ...data };

    if (Array.isArray(formatted.salaryAttachment)) {
        formatted.salaryAttachment = formatted.salaryAttachment.join(",");
    }

    const formatDate = (date) => {
        if (!date) return null;
        if (date instanceof Date) {
            return date.toISOString().split("T")[0];
        }
        return date;
    };

    if (formatted.caseDetailsID && !formatted.caseRowID) {
        formatted.caseRowID = formatted.caseDetailsID;
    }

    formatted.employeeDateOfJoining = formatDate(formatted.employeeDateOfJoining);
    formatted.orderDate = formatDate(formatted.orderDate);
    formatted.effectiveAttachmentStartDate = formatDate(formatted.effectiveAttachmentStartDate);

    return formatted;
};


export const parseAttachmentIds = (attachmentField) => {
    if (!attachmentField) {
        return [];
    }
    if (Array.isArray(attachmentField)) {
        return attachmentField;
    }
    if (typeof attachmentField !== 'string') {
        return [];
    }
    if (attachmentField.trim() === "") {
        return [];
    }
    return attachmentField
        .split(",")
        .map((id) => id.trim())
        .filter((id) => id !== "");
};


export const validateSalaryAttachmentData = (data) => {
    const errors = {};

    if (!data.caseDetailsID) {
        errors.caseDetailsID = "Case ID is required";
    }

    if (!data.salaryAttachmentOrderedUnder) {
        errors.salaryAttachmentOrderedUnder = "This field is required";
    }

    return {
        isValid: Object.keys(errors).length === 0,
        errors,
    };
};

export const salaryFilesDownload = async (values) => {
    try {
        const response = await axios.get(`${api}/documents/asset/salaryAttachment/${values}`, {
            responseType: "blob",
        });

        return response.data;
    } catch (error) {
        return [];
    }
};
